import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { ClientEditRequestBody, ClientEditResponse } from "./types";

export class ClientEditAPI extends BaseAPI<
    ClientEditRequestBody,
    ClientEditResponse
> {
    protected route = ApiRoutes.client.edit;
    protected method = RequestMethod.PATCH;
    protected params = ["id"];
}
